import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export default class Tibbit26EndNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Tibbit 26 End Recording';
        this.id = 'node_tibbit_26_end';
        this.linkedFeature = 'general';
        this.description = 'IR Processor Finish Recording';

        this.inputs = [
            {
                name: 'End Recording',
                portId: 'tbt26_get_data',
                params: [],
            },
        ];

        this.outputs = [
            {
                name: 'Data Available',
                portId: 'tibbit26_data',
                params: [
                    {
                        name: 'data',
                        dataType: TibboDataType.STRING,
                    },
                ],
            },
        ];

        const settings: Setting[] = [
            // {
            //     id: 'ENCODING',
            //     name: 'Encoding',
            //     settingType: SettingType.OPTION,
            //     required: true,
            //     default: '',
            //     options: [
            //         {
            //             name: 'None',
            //             value: '',
            //         },
            //         {
            //             name: 'NEC',
            //             value: 'nec',
            //         },
            //     ],
            // },
            {
                id: 'TIBBIT',
                name: 'Tibbit 26',
                settingType: SettingType.OPTION,
                refId: 'tibbit_26',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;
        const TIBBIT = this.getSettingValue('TIBBIT');
        const tibbit = project.getFeature(TIBBIT);
        if (tibbit === undefined) {
            return blocks;
        }
        const tibbitName = tibbit.getSettingValue('NAME');
        const functionName = `${tibbitName}_data_available`;
        const ENCODING = this.getSettingValue('ENCODING');

        let dataCode = '';

        let links = project.getNodeLinks(this, 'tbt26_get_data');
        for (let i = 0; i < links.length; i += 1) {
            const link = links[i];
            blocks.push({
                location: link.getSourceId(),
                blockType: BlockType.CODE,
                id: link.getID(),
                template: `${functionName}()`,
            });
        }

        links = project.getNodeLinks(this, 'tibbit26_data');
        if (links.length > 0) {
            const link = links[0];
            dataCode += `
            '****${link.getSourceId()}****'`;
        }

        blocks.push({
            location: 'DEVICE_TBS',
            blockType: BlockType.CODE,
            id: this.getID(),
            template: `
sub ${functionName}()
    dim data as string=tbt26_get_data(${tibbitName}_CS, ${tibbitName}_channel)
    ${dataCode}
end sub`,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            id: functionName,
            template: `
declare sub ${functionName}()`,
        });

        return blocks;
    }
}
